import { FormattedMessage } from 'react-intl';
import HexagonIcon from '@/assets/hexagon-dice.svg?react';
import CrownIcon from '@/assets/crown.svg?react';
import StarIcon from '@/assets/star2.svg?react';
import TestTubeIcon from '@/assets/test-tube.svg?react';

export const PartnerTypes = {
  platform: {
    label: (
      <FormattedMessage id="platform" defaultMessage="Platform" />
    ),
    icon: <HexagonIcon />,
  },
  operator: {
    label: (
      <FormattedMessage id="operator" defaultMessage="Operator" />
    ),
    icon: <CrownIcon />,
  },
  brand: {
    label: <FormattedMessage id="brand" defaultMessage="Brand" />,
    icon: <StarIcon />,
  },
  lead: {
    label: <FormattedMessage id="lead" defaultMessage="Lead" />,
    icon: <TestTubeIcon />,
  },
};
